// AlignUI ProgressBar v0.0.0

import * as React from "react";
import { tv } from "../utils/tv";

export const progressBarVariants = tv({
  slots: {
    root: "h-1.5 w-full rounded-full bg-bg-soft-200 overflow-hidden",
    progress: "h-full rounded-full transition-all duration-300 ease-out",
  },
});

type ProgressBarRootProps = React.HTMLAttributes<HTMLDivElement> & {
  value?: number;
  max?: number;
  color?: string; // ✅ now string support
};

const ProgressBarRoot = React.forwardRef<HTMLDivElement, ProgressBarRootProps>(
  (
    {
      className,
      value = 0,
      max = 100,
      color = "#335CFF", // ✅ your default hex color
      ...rest
    },
    forwardedRef
  ) => {
    const { root, progress } = progressBarVariants();

    const safeValue = Math.min(max, Math.max(value, 0));
    const percentage = (safeValue / max) * 100;

    return (
      <div ref={forwardedRef} className={root({ class: className })} {...rest}>
        <div
          className={progress()}
          style={{
            width: `${percentage}%`,
            backgroundColor: color, // ✅ dynamic color
          }}
          role="progressbar"
          aria-valuenow={safeValue}
          aria-valuemax={max}
          aria-valuemin={0}
        />
      </div>
    );
  }
);

ProgressBarRoot.displayName = "ProgressBarRoot";

export { ProgressBarRoot as Root };
